//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    requestBody: {
        displayOrder: number;
        eventTemplateId: string;
        marketSubtype: string;
        name: string;
        sportId: string;
        templateId: string;
    };
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/sport/market-template/create -> post -> ${code}`);
    };
};

export const Response200IO = t.interface({
    allowCompetitionMultiples: t.boolean,
    allowedInMultiplesWith: t.array(t.string),
    betReferralEnabled: t.boolean,
    bp: t.union([t.null, t.undefined, t.boolean]),
    bpApplicable: t.union([t.null, t.undefined, t.boolean]),
    cashoutAvailable: t.boolean,
    cashoutMarketSettings: t.union([t.null, t.undefined, t.interface({
        baseCashout: t.union([t.null, t.undefined, t.number]),
        cashoutOfferEasing: t.union([t.null, t.undefined, t.number]),
        cashoutOverround: t.union([t.null, t.undefined, t.number]),
    })]),
    displayName: t.union([t.null, t.undefined, t.string]),
    displayOrder: t.number,
    eachWaySettings: t.union([t.null, t.undefined, t.interface({
        legacyOffered: t.boolean,
        offered: t.boolean,
        termsWithBet: t.boolean,
    })]),
    eachWayStakeReduction: t.number,
    eventTemplate: t.union([t.null, t.undefined, t.interface({
        id: t.string,
    })]),
    id: t.string,
    inPlayDelay: t.number,
    marketName: t.string,
    marketSubtype: t.union([t.null, t.undefined, t.string]),
    matchingMarkets: t.union([t.null, t.undefined, t.string]),
    metadata: t.union([t.null, t.undefined, t.record(t.string, t.string)]),
    multipleInstancesAllowed: t.boolean,
    platformObject: t.union([t.null, t.undefined, t.interface({
        eventTemplateId: t.string,
        id: t.string,
        name: t.string,
        sportId: t.string,
    })]),
    selections: t.array(t.interface({
        autoCreate: t.boolean,
        displayOrder: t.number,
        id: t.string,
        name: t.string,
        tags: t.record(t.string, t.string),
        type: t.union([t.null, t.undefined, t.string]),
    })),
    selectionsNewTrading: t.union([t.null, t.undefined, t.string]),
    settlementDelay: t.number,
    singlesOnly: t.boolean,
    sp: t.union([t.null, t.undefined, t.boolean]),
    spApplicable: t.union([t.null, t.undefined, t.boolean]),
    sport: t.union([t.null, t.undefined, t.interface({
        id: t.string,
    })]),
    tags: t.record(t.string, t.string),
    url: t.string,
});
export type Response200Type = {
    allowCompetitionMultiples: boolean;
    allowedInMultiplesWith: Array<string>;
    betReferralEnabled: boolean;
    bp?: null | undefined | boolean;
    bpApplicable?: null | undefined | boolean;
    cashoutAvailable: boolean;
    cashoutMarketSettings?: null | undefined | {
        baseCashout?: null | undefined | number;
        cashoutOfferEasing?: null | undefined | number;
        cashoutOverround?: null | undefined | number;
    };
    displayName?: null | undefined | string;
    displayOrder: number;
    eachWaySettings?: null | undefined | {
        legacyOffered: boolean;
        offered: boolean;
        termsWithBet: boolean;
    };
    eachWayStakeReduction: number;
    eventTemplate?: null | undefined | {
        id: string;
    };
    id: string;
    inPlayDelay: number;
    marketName: string;
    marketSubtype?: null | undefined | string;
    matchingMarkets?: null | undefined | string;
    metadata?: null | undefined | Record<string, string>;
    multipleInstancesAllowed: boolean;
    platformObject?: null | undefined | {
        eventTemplateId: string;
        id: string;
        name: string;
        sportId: string;
    };
    selections: Array<{
        autoCreate: boolean;
        displayOrder: number;
        id: string;
        name: string;
        tags: Record<string, string>;
        type?: null | undefined | string;
    }>;
    selectionsNewTrading?: null | undefined | string;
    settlementDelay: number;
    singlesOnly: boolean;
    sp?: null | undefined | boolean;
    spApplicable?: null | undefined | boolean;
    sport?: null | undefined | {
        id: string;
    };
    tags: Record<string, string>;
    url: string;
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyStaffCreateMarketTemplateRequest"
 */
export const openapi_proxy_staff_create_market_template = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/staff/sport/market-template/create${query}`;
    
    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyStaffCreateMarketTemplateParamsType = ParamsType;

export type OpenapiProxyStaffCreateMarketTemplateResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyStaffCreateMarketTemplateResponse200Type = Response200Type;

export const openapiProxyStaffCreateMarketTemplateRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyStaffCreateMarketTemplateResponseType> => {
    const response = await openapi_proxy_staff_create_market_template(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyStaffCreateMarketTemplateRequest - unhandled response ${response.status}`);
};

